import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/store'
import 'vant/lib/index.css';
import Vant from 'vant'
import 'amfe-flexible/index.js'
import './utils/rotate'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import VueResource from 'vue-resource'


Vue.use(VueResource)
Vue.use(Vant)
Vue.config.productionTip = false
Vue.use(ElementUI, { zhLocale })
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
